{
    "TargetreportformatLabel": "Format du rapport cible :",
    "TargetreportformatPdfOptionLabel": "Document PDF",
    "TargetreportformatRtfOptionLabel": "Document RTF",
    "TargetreportformatCsvOptionLabel": "Exportation CSV",
    "UselanguageLabel": "Utilisez le langage :",
    "UselanguageEnusOptionLabel": "Anglais (États-Unis)",
    "UselanguageEngbOptionLabel": "Anglais (Royaume-Uni)",
    "PapersizeLabel": "Taille du papier :",
    "PapersizeA4OptionLabel": "A4 (210 mm x 297 mm)",
    "PapersizeLegalOptionLabel": "Legal (8½\" x 14\")",
    "PapersizeLetterOptionLabel": "Lettre (8½\" x 11\")",
    "Format_SectionHeader": "Format",
    "NAME": "Format",
    "TargetreportformatXlsOptionLabel": "Exportation XLS"
}